import ReactMarkdown from "react-markdown";

export default function MarkdownContent({ source }) {
  return (
    <ReactMarkdown
      skipHtml
      components={{ a: ({ children }) => <span>{children}</span> }}
    >
      {source || ""}
    </ReactMarkdown>
  );
}
